<script setup>
import { onMounted, ref } from 'vue'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useSettings } from '@store/settings.js'
const $settings = useSettings()

import { useCustomizer } from '@store/customizer.js'
const $customizer = useCustomizer()

import { Button } from '@components'
import Main from '../layout/Main.vue'
import TimeSlot from './TimeSlot.vue'
import TimeLoader from './TimeLoader.vue'
import MiniCalendar from './MiniCalendar.vue'

// Fetch Slots.
onMounted(async () => {
    // // $appointments.matchAppointmentPreRequirement()
    console.log('time')
    $appointments.fetchAvailableDates()
    $appointments.fetchAvailableSlots()
})

const updateAppointment =async (value) => {
   await $appointments.setAppointment('booking_date', value, false)
    $appointments.fetchAvailableSlots()
}
</script>

<style lang="scss" scoped></style>

<template>
    <Main>
        <template #content>
            <div class="time-page-title" :style="$customizer.titleStyle">{{ $settings.customizer.time.title }}</div>

            <!-- mini calendar -->
            <MiniCalendar v-model="$appointments.appointment.booking_date" @change="(value) => updateAppointment(value)" v-if="$appointments.appointment.booking_date" />

            <!-- divider -->
            <div class="w-full h-[1px] bg-[#EAECF0] my-5"></div>

            <div>
                <div class="time-picker-headline">{{ $settings.customizer.time.slot_subtitle }} {{ `${$appointments.selectedDate?.month} ${$appointments.selectedDate?.date}` }}</div>
                <!-- time loader -->
                <TimeLoader v-if="!$appointments.isAvailableSlotsLoaded" />

                <!-- time list -->
                <div v-if="$appointments.isAvailableSlotsLoaded">
                    <div :class="`time-list ${$settings.isWidget ? 'grid-cols-2' : ''}`">
                        <TimeSlot v-for="(slot, index) in $appointments.availableSlots" :key="index" :slot="slot" />
                    </div>
                    <div v-if="$appointments.isAvailableSlotsLoaded && !$appointments.availableSlots.length" class="text-[#984545]">No available time found. Please select another date</div>
                </div>
            </div>
        </template>

        <!-- footer button -->
        <template #footer>
            <Button type="primary" size="md" radius="square" class="w-full" :buttonStyle="$customizer.buttonStyle" @click="$appointments.nextStep()">{{ $settings.customizer.time.continue_button }}</Button>
        </template>
    </Main>
</template>